import * as t from 'io-ts';

export const ImageDynamicType = t.interface({
    url: t.string,
    thumbnailUrl: t.string
});

export type Image = t.TypeOf<typeof ImageDynamicType>;
